<template>
    <div div name="pc-connci-sub2" class="pc-barocare-connci-sub2">
        <template>
            <BarocareConciHeaderSub />
        </template>
        <div class="sub2-container">
          <div class="main-content">
            <div class="left-sidebar">
                <nav class="navigation">
                    <ul>
                        <li><router-link to="/barocarenew">메인으로</router-link></li>
                        <li><router-link to="/barocarenew/sub2" class="cta_001">서비스 특장점</router-link></li>
                        <li class="select"><router-link to="/barocarenew/sub3" class="cta_002">이용방법</router-link></li>
                        <li><router-link to="/barocarenew/sub1" class="cta_003">구매 가능 품목</router-link></li>
                        <li><router-link to="/barocarenew/sub5" class="cta_004">인슐린 약국 찾기</router-link></li>
                        <li><router-link to="/barocarenew/sub4" class="cta_005">자주 묻는 질문</router-link></li>
                    </ul>
                </nav>
            </div>

            <div class="content">
                <div class="content-header">
                    <div class="content-box sub3">
                    </div>
                    <h2>이용방법 : 어떻게 이용하나요?</h2>
                    <ul class="box-list">
                        <li>
                            <span>고객 정보 <br> 등록하기</span>
                        </li>
                        <li>
                            <span>간편 비대면진료 <br> 이용하기</span>
                        </li>
                        <li>
                            <span>소모성 재료 <br> 구입하기</span>
                        </li>
                        <li>
                            <span>약국에서 <br> 인슐린 수령하기</span>
                        </li>
                    </ul>
                </div>

                <div class="section info-section">
                  <div class="way-header">1. 서비스를 이용할 고객 정보 등록하기</div>
                  <ul class="way-list">
                    <li><span>1.</span><strong>환자 개인정보</strong>와 <strong>결제용 카드</strong>를 미리 등록해 주세요.</li>
                    <li><span>2.</span>환자등록 시 <strong>위임장</strong> 작성은 필수입니다. 이는 솔닥을 통한 물품 구매와 위임 청구에 필요합니다.</li>
                    <li><span>3.</span>환자등록은 <strong>처음 한 번만</strong> 하면 됩니다. 이후 바로 솔닥컨시어지 서비스를 이용하실 수 있어요.</li>
                    <li><span>4.</span>등록이 완료되면 <strong>비대면진료 예약</strong>이나 <strong>소모성재료 구입</strong> 등 원하는 서비스를 이용하세요.</li>
                  </ul>
                  <a href="https://baro.soldoc.co.kr/register" target="_blank" class="btn-indigo">환자 등록 하러가기</a>
                </div>

                 <div class="section info-section">
                  <div class="way-header">2. 비대면진료 간편하게 이용하기</div>
                  <ul class="way-list">
                    <li><span>1.</span><strong>솔닥컨시어지 고객센터</strong>에 진료 요청사항을 남겨주세요.</li>
                    <li><span>2.</span><strong>상담원과 채팅</strong>으로 진료 시간을 예약합니다.</li>
                    <li><span>3.</span><strong>예약 시간</strong>에 병원에서 전화를 드리며, 통화로 진료가 진행됩니다.</li>
                    <li><span>4.</span>진료 후 <strong>처방전, 영수증 등 진료 문서</strong>를 카카오톡으로 보내드립니다.</li>
                    <li><span>5.</span>필요한 <strong>소모성재료</strong>는 진료 후 함께 구매하실 수 있습니다.</li>
                  </ul>
                  <a href="https://solcon.channel.io/home" target="_blank" class="btn-indigo">비대면진료 예약하기</a>
                </div>

                 <div class="section info-section">
                  <div class="way-header">3. 당뇨병 소모성재료 구입하기</div>
                  <ul class="way-list">
                    <li><span>1.</span><strong>솔닥 <a href="https://baro.soldoc.co.kr/calc" target="_blank">소모성재료 계산기</a></strong>로 예상 결제 금액을 먼저 확인하세요.</li>
                    <li><span>2.</span>원하시는 <strong>물품 이름과 수량을 채팅</strong>으로 알려주세요.</li>
                    <li><span>3.</span>물품을 신청하면 상담원 확인 후 <strong>자동으로 결제 및 배송 준비</strong>가 시작됩니다.</li>
                    <li><span>4.</span><strong>본인 부담금</strong>만 결제하시면 됩니다. 나머지는 솔닥이 공단에 청구해드립니다.</li>
                    <li><span>5.</span><strong>배송받을 주소</strong>와 요청사항을 입력해주세요.</li>
                    <li><span>6.</span>소모성재료처방전이 없다면, 먼저 비대면진료로 처방전을 받아주세요.</li>
                  </ul>
                  <a href="https://solcon.channel.io/home" target="_blank" class="btn-indigo">소모성 재료 구입하기</a>
                </div>

                 <div class="section info-section">
                  <div class="way-header">4. 근처 약국에서 인슐린 수령하기 </div>
                  <ul class="way-list">
                    <li><span>1.</span>인슐린을 받으실 근처 약국을 미리 찾아주세요.</li>
                    <li><span>2.</span>약국의 인슐린 재고와 비대면진료 처방전 접수 가능 여부를 확인해주세요.</li>
                    <li><span>3.</span>비대면진료 예약 시 약국 정보를 알려주시면 솔닥을 통한 처방전 전송이 가능합니다.</li>
                    <li><span>4.</span>약국에서 약값을 결제하고 인슐린을 수령하세요.</li>
                  </ul>
                  <a href="https://solcon.channel.io/home" target="_blank" class="btn-indigo">비대면진료 예약하기</a>
                </div>
                <div class="section info-section last">
                    <p><strong>고객정보 등록</strong>부터 <strong>진료 예약, 소모성재료 구입, 인슐린 수령</strong>까지 모든 과정을 간편하게 이용하실 수 있습니다. 궁금하신 점은 <strong>솔닥컨시어지 고객센터</strong>로 언제든 문의해주세요!</p>
                </div>
            </div>

            <div class="right-sticky-menu box">
                <div class="box-top">
                  <strong><i class="ico-quest"></i>더 궁금한 점이 있나요?</strong>
                  <p>솔닥 컨시어지 상담사와 전화 또는 채팅 상담으로 문의주시면 친절히 답변해 드립니다.</p>
                </div>
                <!-- <div class="box-bot">
                  <div class="left">
                    <strong>솔닥 컨시어지</strong>
                    <span>카카오톡 상담 바로가기</span>
                  </div>
                  <div class="right">
                    <img src="../assets/pc_barocare_conci/img-qr.png" alt="카카오톡 상담 큐알코드">
                  </div>
                </div> -->
            </div>
          </div>
       </div>
    </div>
</template>

<script>
import BarocareConciHeaderSub from '@/components/pc_barocare_conci/BarocareConciHeaderSub';

export default {
    name: 'BarocareConciSub2Pc',
    components: {
        BarocareConciHeaderSub,
    },
    data() {
        return {
            // 현재 경로가 서브 페이지인지를 체크
            isSubPage: this.$route.path.includes('/sub')
        };
    },
    watch: {
        // 경로가 변경될 때마다 isSubPage 값을 업데이트
        '$route.path'(newPath) {
            this.isSubPage = newPath.includes('/sub');
        }
    },
    mounted() {
        // 페이지가 로드되면 스크롤을 맨 위로
        $('html').animate({
            scrollTop: 0
        }, 100);

        // 스크롤 이벤트 리스너 추가
        window.addEventListener('scroll', this.updateActiveSection);
    },
    beforeDestroy() {
        // 컴포넌트 파괴 전 스크롤 이벤트 리스너 제거
        window.removeEventListener('scroll', this.updateActiveSection);
    },
methods: {
    scrollToSection(sectionId) {
        const element = document.getElementById(sectionId);
        if (element) {
            const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 77;

            // 스크롤 이동
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    },
    updateActiveSection() {
        const sections = document.querySelectorAll('.section');
        const menuItems = document.querySelectorAll('.right-sticky-menu li');
        
        // 모든 메뉴 아이템에서 'selected' 클래스 제거
        menuItems.forEach(item => item.classList.remove('selected'));

        // 가장 가까운 섹션을 추적
        let closestSection = null;
        let minDistance = Infinity; // 윈도우 상단과의 최소 거리
        
        // 현재 윈도우 상단에 가장 가까운 섹션 찾기
        for (let section of sections) {
            const rect = section.getBoundingClientRect();
            const sectionHeight = section.offsetHeight;
            
            // 섹션의 top 값과 윈도우 상단과의 거리를 계산
            const distanceFromTop = Math.abs(rect.top);
            
            // 최소 거리를 찾음
            if (distanceFromTop < minDistance) {
                minDistance = distanceFromTop;
                closestSection = section;
            }
        }

        // 가장 가까운 섹션에 selected 클래스 추가
        if (closestSection) {
            const sectionId = closestSection.id;
            const activeMenuItem = [...menuItems].find(
                item => item.querySelector('a').getAttribute('href') === `#${sectionId}`
            );
            
            if (activeMenuItem) {
                activeMenuItem.classList.add('selected');
            }
        }
    }
}
}
</script>
<style lang="scss">
@import "../styles/PcBarocareConci.scss";
</style>


// WEBPACK FOOTER //
// src/page/PcBarocareSub3.vue